module.exports = __webpack_public_path__ + "img/app-ks.fc913d5d.png";